import { rest } from 'msw'
import moment from 'moment'
moment.locale('ja')
export default [
  /**
   * スタンプシート一覧情報
   */
  rest.post('/api/v2/get_stampsheet_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    const count = 4
    const page = req.body.page
    const data = [
      {
        id: 1,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 2,
          cardCount: 3,
          stampCount: 11,
        },
        isEntry: 1,
        progress: { cardCount: 1, stampCount: 7, stampCountTotal: 18 },
        logic: 1,
      },
      {
        id: 2,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 2,
          cardCount: 3,
          stampCount: 11,
        },
        isEntry: 1,
        progress: { cardCount: 2, stampCount: 0, stampCountTotal: 22 },
        logic: 2,
      },
      {
        id: 3,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 2,
          cardCount: 3,
          stampCount: 11,
        },
        isEntry: 1,
        progress: { cardCount: 2, stampCount: 11, stampCountTotal: 22 },
        logic: 0,
      },
      {
        id: 4,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
      },
      {
        id: 5,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 6,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(4, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(4, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 7,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 8,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 9,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 10,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 11,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 12,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 13,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 14,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 15,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 16,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 17,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 18,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 19,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 20,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 21,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 22,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 23,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 24,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
      {
        id: 25,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        openDate: moment().add(-2, 'days').unix(),
        closeDate: moment().add(-1, 'days').unix(),
        periodStart: moment().add(-2, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
        },
        isEntry: 0,
        progress: { cardCount: 0, stampCount: 0, stampCountTotal: 0 },
        logic: 0,
      },
    ]
    const totalPage = Math.ceil(data.length / count)
    const items = data.splice((page - 1) * count, count)
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items,
          count,
          totalCount: data.length,
          totalPage,
          responseTime: 1607318901,
        },
      })
    )
  }),
  /**
   * スタンプシート詳細情報
   */
  rest.post('/api/v2/get_stampsheet_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    const id = req.body.id
    const data = [
      {
        id: 1,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        chain: {
          id: 0,
          name: '阪急OASIS',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointName: '',
        point: 100,
        hasEntry: 1,
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        logic: 0,
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 2,
          cardCount: 3,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 0,
        progress: { cardCount: 1, stampCount: 7, stampCountTotal: 18 },
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 1,
          dispName: '',
          jan_type: 1,
        },
        target2: {
          products: [],
          quantity: 0,
          amount: 0,
          dispName: '',
          jan_type: 1,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 2,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 2,
          cardCount: 3,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 2, stampCount: 0, stampCountTotal: 22 },
        logic: 0,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 1,
          dispName: '',
          jan_type: 1,
        },
        target2: {
          products: [],
          quantity: 0,
          amount: 0,
          dispName: '',
          jan_type: 1,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 3,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 2,
          cardCount: 3,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 2, stampCount: 11, stampCountTotal: 22 },
        logic: 0,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 4,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 5,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 6,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 50,
          stampCount: 3,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 3, stampCount: 2, stampCountTotal: 11 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 7,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 8,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(-1, 'hours').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 9,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 10,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 11,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 12,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 13,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 14,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 15,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 16,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 17,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 18,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 19,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 20,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 21,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 22,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 23,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 24,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
      {
        id: 25,
        title: 'API\u30C6\u30B9\u30C8',
        mainImage:
          'https://static-stg.retailstudio.jp/assets/stamps/9/729fc02793abf64856bf1641b5be417e.png',
        mainImageAttribute: {
          height: 220,
          width: 220,
        },
        detail: 'キャンペーン詳細',
        pointName: '',
        point: 100,
        hasEntry: 1,
        chain: {
          id: 7,
          name: '\u962A\u6025\u30AA\u30A2\u30B7\u30B9',
          logo:
            'https://static-stg.retailstudio.jp/assets/companies/7/editor.jpg',
        },
        pointTarget: 0,
        openDate: moment().add(-1, 'days').unix(),
        closeDate: moment().add(10, 'days').unix(),
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(10, 'days').unix(),
        entryStart: '1643652930',
        entryEnd: '',
        exchangeStart: '',
        exchangeEnd: '',
        isPurchaseOnly: 0,
        sheetinfo: {
          type: 1,
          cardCount: 1,
          stampCount: 11,
          stampPattern: 1,
          point: 10,
          dispPoint: null,
          step2StampCount: null,
          step2Point: null,
        },
        isEntry: 1,
        progress: { cardCount: 0, stampCount: 9, stampCountTotal: 9 },
        logic: 2,
        target1: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 青椒肉絲用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 酢豚用',
              unit: 1,
              salesCount: 1,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 回鍋肉用',
              unit: 1,
              salesCount: 0,
            },
            {
              jancode: '4973460300378',
              name: 'CookDo 豚肉ともやしの四川香味炒め用',
              unit: 1,
              salesCount: 0,
            },
          ],
          quantity: 1,
          amount: 2,
          dispName: '',
          jan_type: 2,
        },
        bonus: {
          products: [],
        },
        executedAt: '',
        mustAmount: 0,
        taxType: 1,
        purchaseTarget: 0,
        shops: [],
        condition: '',
        caution:
          '・スタンプ企画のご参加にあたり、「エントリー」が必要となります。\r\n※エントリー方法は、使い方ガイドをご参照ください。\r\n・ご購入の際は、LINEミニアプリに登録されているポイントカードをレジでご提示ください。\r\n・スタンプの反映には1～2週間程度かかりますので、あらかじめご了承のほどお願いいたします。\r\n・スタンプの達成状況は、各スタンプ企画の「スタンプカード」をご確認ください。\r\n・店舗により、一部お取り扱いのない場合がございます。万一、品切れ、および入荷がない場合はご容赦くださいませ。',
        appNo: '005-00223',
      },
    ]
    const filter = data.filter(item => item.id === Number(id))
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: filter[0] || {},
      })
    )
  }),
  /**
   * スタンプシートエントリー
   */
  rest.post('/api/v2/entry_stampsheet', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          status: 1,
          responseTime: '915148799',
        },
      })
    )
  }),
]
